import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Modal, Row, Steps } from 'antd'
import client from 'apollo'

import './verification.css'
import { AppContext } from 'AppContext'
import { UPDATE_USER } from 'modules/Users/graphql/Mutations'
import checkCircleForStep from 'assets/images/new-images/checkCircleForStep.svg'
import InvestmentPlanningNew from './InvestmentPlanningNew'
import EMandateRegistrationNew from './EMandateRegistrationNew'
import CongratulationsNew from './CongratulationsNew'
import PendingBookedAdvisoryNew from './PendingBookedAdvisoryNew'
import { GET_ALL_NOTIFICATION_FOR_CLIENT } from 'auth/graphql/Queries'
import { RedoOutlined } from '@ant-design/icons'
import {
  GET_BOOKING_ADVISORY,
  GET_NEW_PENDING_ADVISORY,
} from './graphql/Queries'
import moment from 'moment'
import openNotification from 'utils/Notification'
import { UPDATE_ADVISORY_STATUS } from 'modules/PendingAdvisory/graphql/Mutation'
import { UPDATE_BOOK_ADVISORY } from './graphql/Mutations'

const { Step } = Steps
const { warning } = Modal

// const indexToKey = [
//   'KYC_FORM',
//   'INVESTMENT_PLANNING',
//   'ADVISORY_FEES',
//   'CONGRATULATION',
//   'DONE',
// ]

const AuaNewSteps = () => {
  const {
    dispatch,
    state: { currentUser },
  } = useContext(AppContext)
  const { state } = useContext(AppContext)
  const { newAuaAdvisoryCompletedSteps } = state?.currentUser

  const [disableButton, setDisableButton] = useState(false)
  const [data, setData] = useState(null)

  useEffect(() => {
    const fetchAdvisoryData = async () => {
      if (newAuaAdvisoryCompletedSteps !== 'KYC_FORM') {
        if (newAuaAdvisoryCompletedSteps === 'CONGRATULATION') {
          try {
            const res = await client.query({
              query: GET_NEW_PENDING_ADVISORY,
              variables: {
                where: { advisoryDate: '' },
                data: { source: 'ADD AUA' },
              },
              fetchPolicy: 'network-only',
            })

            const advisory = res?.data?.getNewBookingAdvisory
            setData(advisory)

            setDisableButton(
              advisory?.createdAt &&
              !moment(advisory.createdAt).isSame(moment(), 'day'),
            )
          } catch (err) {
            openNotification('error', err?.message)
            console.error(err)
          }
        }
      }
    }

    fetchAdvisoryData()
  }, [newAuaAdvisoryCompletedSteps, currentUser])

  useEffect(() => {
    let newTempCurrent = 0
    switch (newAuaAdvisoryCompletedSteps) {
      case 'INVESTMENT_PLANNING':
        newTempCurrent = 1
        break
      case 'ADVISORY_FEES':
        newTempCurrent = 2
        break
      case 'CONGRATULATION':
        newTempCurrent = 3
        break
      case 'DONE':
        newTempCurrent = 4
        break
      default:
        break
    }
    setCurrent(newTempCurrent)
  }, [newAuaAdvisoryCompletedSteps])

  let modal

  const handleReset = () => {
    if (newAuaAdvisoryCompletedSteps !== 'KYC_FORM') {
      if (newAuaAdvisoryCompletedSteps === 'CONGRATULATION') {
        modal = warning({
          centered: true,
          okButtonProps: { style: { display: 'none' } },
          cancelButtonProps: { style: { display: 'none' } },
          content: (
            <>
              <ModalContent
                modal={modal}
                disableButton={disableButton}
                rejectAdvisoryFunction={rejectAdvisoryFunction}
              />
            </>
          ),
        })
      } else {
        client
          .mutate({
            mutation: UPDATE_USER,
            variables: {
              data: { newAuaAdvisoryCompletedSteps: 'KYC_FORM' },
              id: currentUser?.id,
            },
          })
          .then((res) => {
            setCurrent(2)
            dispatch({ type: 'CURRENT_USER', data: res.data.updateUser })
            setCurrent(0)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }

  const rejectAdvisoryFunction = async () => {
    if (!disableButton) {
      const bookAdvisoryData = await client.query({
        query: GET_BOOKING_ADVISORY,
        variables: {
          where: { userId: +currentUser?.id },
        },
      })
      if (bookAdvisoryData) {
        const statusData = data.currentAdvisoryData.map((d) => {
          return {
            advisorId: parseInt(d.AdvisorID),
            clientCode: d.ClientCode,
            status: 'Reject',
            source:
              currentUser?.role !== 'CLIENT'
                ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                : window?.location?.pathname === '/add-aua-verification'
                  ? 'ADD AUA'
                  : window?.location?.pathname === '/pending-advisory'
                    ? 'Pending Advisory'
                    : 'Onboarding',
          }
        })
        await client
          .mutate({
            mutation: UPDATE_ADVISORY_STATUS,
            variables: { data: statusData },
          })
          .then(async (res) => {
            res?.data?.updateAdvisoryStatus === true
              ? openNotification('info', 'Rejected Successfully')
              : openNotification('error', 'Something went wrong')

            await client
              .mutate({
                mutation: UPDATE_BOOK_ADVISORY,
                variables: {
                  data: {
                    isCancelAdvisory: true,
                    advisoryCancelBy: currentUser?.id,
                    isPendingAdvisoryAccepted: true,
                    userId: currentUser?.id,
                    source:
                      currentUser?.role !== 'CLIENT'
                        ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                        : window?.location?.pathname === '/add-aua-verification'
                          ? 'ADD AUA'
                          : window?.location?.pathname === '/pending-advisory'
                            ? 'Pending Advisory'
                            : 'Onboarding',
                  },
                  where: {
                    id: parseInt(bookAdvisoryData?.data?.getBookAdvisory?.id),
                  },
                },
              })
              .then(async (res) => {
                await client
                  .mutate({
                    mutation: UPDATE_USER,
                    variables: {
                      data: {
                        newAuaAdvisoryCompletedSteps: 'KYC_FORM',
                        isBookingAdvisoryDateSelected: false,
                        isNewAuaAdvisoryGenerate: false,
                      },
                      id: currentUser?.id,
                    },
                  })
                  .then((res) => {
                    dispatch({
                      type: 'CURRENT_USER',
                      data: res.data.updateUser,
                    })
                    setCurrent(0)
                    Modal.destroyAll()
                  })
                  .catch((err) => {
                    console.log(err)
                  })
              })
              .catch((err) => console.log(err))
          })
      }
    }
  }

  const [current, setCurrent] = useState(0)

  const next = async (nextStep = 1, updatedUser) => {
    const user = updatedUser || currentUser
    const hasMandate = !!user?.umrnNumber
    const fee = Number(user?.mandateAmount) || 0
    const limit = Number(user?.compareMandateAmount) || 0
    const isFeeWithinLimit = fee > 0 && fee <= limit

    console.log('AUA NEXT FUNCTION CALLED:', {
      currentStep: current,
      nextStep,
      fee,
      limit,
      hasMandate,
      isFeeWithinLimit,
      newAuaAdvisoryCompletedSteps: user?.newAuaAdvisoryCompletedSteps,
    })

    if (current === 0) {
      if (hasMandate && isFeeWithinLimit) {
        console.log('SKIP LOGIC TRIGGERED: Fee is within limit. Skipping to Congratulations.')
        client
          .mutate({
            mutation: UPDATE_USER,
            variables: {
              data: { newAuaAdvisoryCompletedSteps: 'ADVISORY_FEES' },
              id: user?.id,
            },
          })
          .then((res) => {
            dispatch({ type: 'CURRENT_USER', data: res.data.updateUser })
            setCurrent(2) // Move to Congratulations (Step 2)
          })
          .catch((err) => {
            console.log('Error updating step:', err)
            setCurrent(current + nextStep)
          })
        return
      }
      console.log('E_MANDATE_DECISION_AUA: SHOW_E_MANDATE', {
        userId: user?.id,
        totalNetAmount: fee,
        compareMandateAmount: limit,
      })
    }

    setCurrent(current + nextStep)
  }
  const back = () => {
    if (newAuaAdvisoryCompletedSteps === 'CONGRATULATION') {
      client
        .query({
          query: GET_ALL_NOTIFICATION_FOR_CLIENT,
          fetchPolicy: 'network-only',
        })
        .then((res) => {
          dispatch({
            type: 'ALL_NOTIFICATIONS_FOR_CLIENT',
            data: res?.data?.getNotifications,
          })
          setCurrent(0)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  const steps = [
    {
      title: 'Investment Planning',
      content: (
        <InvestmentPlanningNew
          next={next}
          reEvaluate={currentUser.reEvaluate}
        />
      ),
    },
    {
      title: 'Advisory Fees',
      content: (
        <EMandateRegistrationNew
          next={next}
          reEvaluate={currentUser.reEvaluate}
        />
      ),
    },
    {
      title: 'Congratulations',
      content: (
        <CongratulationsNew next={next} reEvaluate={currentUser.reEvaluate} />
      ),
    },
    {
      title: 'Pending Advisory',
      content: (
        <PendingBookedAdvisoryNew
          next={next}
          back={back}
          reEvaluate={currentUser.reEvaluate}
        />
      ),
    },
  ]

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col lg={6} sm={24} className='aua_New_Steps_Container'>
            <div className='menu-wrapper'>
              <div style={{ display: 'flex', gap: '5px' }}>
                <RedoOutlined style={{ fontSize: 20 }} />
                <u>
                  <p
                    style={{
                      cursor: 'pointer',
                      color: '#AF0000',
                    }}
                    onClick={handleReset}
                  >
                    Reset
                  </p>
                </u>
              </div>
              <Steps
                direction='vertical'
                current={current}
                status='process'
              >
                {steps?.map((step, index) => (
                  <Step
                    key={index}
                    title={step.title}
                    icon={
                      index < current ? (
                        <img
                          src={checkCircleForStep}
                          alt='checkCircleForStep'
                        />
                      ) : null
                    }
                  />
                ))}
              </Steps>
            </div>
          </Col>
          <Col lg={18} sm={24}>
            <div className='steps-content' style={{ marginTop: '2dvh' }}>
              {steps[current]?.content}
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
const ModalContent = ({ disableButton, modal, rejectAdvisoryFunction }) => {
  const [rejectLoading, setRejectLoading] = useState(false)

  const rejectAdvisory = async () => {
    if (!disableButton) {
      setRejectLoading(true)
      await rejectAdvisoryFunction()
      setRejectLoading(false)
    }
  }

  return (
    <div>
      <div className='modal_text'>
        To reset, kindly accept or reject the current advisory
      </div>
      <div className='book_advisory_btn'>
        <Button
          className='advisory_cancel_btn'
          onClick={() => Modal.destroyAll()}
          disabled={false}
        >
          Cancel
        </Button>
        <Button
          className='advisory_verify_btn'
          type='primary'
          disabled={disableButton}
          loading={rejectLoading}
          onClick={() => rejectAdvisory()}
        >
          Reject Advisory
        </Button>
      </div>
      {disableButton && (
        <div className='note_text' style={{ marginTop: 16, color: 'red' }}>
          * You can’t reject now — the debit presentation request is already in
          progress.
        </div>
      )}
    </div>
  )
}

export default AuaNewSteps
